import { useSelector } from 'react-redux';
import { VariantPill } from 'modules/experiments/components/ui';
import { useTakeoverExperimentContext, useVariantCardContext } from 'modules/experiments/contexts';
import { dataTestId, deletingCardState } from 'modules/experiments/constants';
import { useExperimentsUserPermission } from 'modules/experiments/hooks';
import { getTakeoverCampaignMessageMedium } from 'modules/experiments/ducks/selectors';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Delete, Edit16 } from 'ui/icons';
import { colors } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';
import {
  VariantActionButtons,
  VariantHeaderTitleWrapper,
  VariantHeaderWrapper,
  VariantNameWrapper,
} from './Styled';
import { VariantName } from './VariantName';

export const VariantHeader = () => {
  const campaignMessageMedium = useSelector(getTakeoverCampaignMessageMedium);
  const { viewOnlyPermission } = useExperimentsUserPermission(campaignMessageMedium);
  const { isSTOExperiment, isSendTimeExperiment, isRunningExperiment } =
    useTakeoverExperimentContext();
  const {
    variant,
    updatingCard,
    deletingCard,
    isCardInEditMode,
    isCardInPreviewMode,
    deleteCard,
    editCard,
  } = useVariantCardContext();
  const { alphabet, bgColor, textColor, control } = variant;

  if (deletingCardState.includes(deletingCard)) {
    return (
      <VariantHeaderWrapper>
        <Skeleton height={25} />
      </VariantHeaderWrapper>
    );
  }

  return (
    <VariantHeaderWrapper>
      <VariantHeaderTitleWrapper>
        <VariantPill bgColor={bgColor} textColor={textColor}>
          {alphabet}
        </VariantPill>
        <VariantNameWrapper>
          <VariantName />
        </VariantNameWrapper>
      </VariantHeaderTitleWrapper>
      <VariantActionButtons
        data-test={dataTestId.variantActionButtons}
        isControl={control}
        isEditMode={isCardInEditMode}
        isPreviewMode={isCardInPreviewMode}
        isSendTimeExperiment={isSendTimeExperiment}
        isViewOnlyPermission={viewOnlyPermission}
        onClick={(e) => e.stopPropagation()}
      >
        {!updatingCard && (
          <>
            {!(isRunningExperiment && isSendTimeExperiment) && (
              <IconButton
                data-test={dataTestId.variantEditButton}
                size={BUTTON_SIZES.SMALL}
                variant={BUTTON_VARIANTS.GHOST}
                onClick={editCard}
              >
                <Edit16 color={colors.textSecondary} />
              </IconButton>
            )}
            {!isSTOExperiment && !isRunningExperiment && !(isSendTimeExperiment && control) && (
              <IconButton
                data-test={dataTestId.variantDeleteButton}
                size={BUTTON_SIZES.SMALL}
                variant={BUTTON_VARIANTS.GHOST}
                onClick={deleteCard}
              >
                <Delete height={16} width={16} color={colors.textSecondary} />
              </IconButton>
            )}
          </>
        )}
      </VariantActionButtons>
    </VariantHeaderWrapper>
  );
};
